export default __webpack_public_path__ + "static/media/newLogo.bdbf733c.png";